import React, { useEffect, useState } from 'react';

function WaitlistPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [waitlistCount] = useState(3847);

  useEffect(() => {
    setTimeout(() => {
      if (window.WOW) {
        try {
          new window.WOW().init();
        } catch (e) {
          console.log('WOW.js not available');
        }
      }
    }, 500);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
      setEmail('');
      setTimeout(() => {
        setSubmitted(false);
      }, 5000);
    }
  };

  return (
    <>
      {/* Page Header Start */}
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: 'url(/assets/images/backgrounds/slider-1-3.jpg)' }}></div>
        <div className="container">
          <div className="page-header__inner">
            <h2 className="page-header__title">Join Our Waitlist</h2>
            <ul className="thm-breadcrumb">
              <li><a href="/">Home</a></li>
              <li><span>/</span></li>
              <li><span>Waitlist</span></li>
            </ul>
          </div>
        </div>
      </section>
      {/* Page Header End */}

      {/* Waitlist Section Start */}
      <section className="waitlist-section" style={{
        padding: '120px 0',
        backgroundColor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        backgroundImage: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: '#fff',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="waitlist-content wow fadeInUp text-center">
                <h1 style={{ fontSize: '48px', marginBottom: '20px', fontWeight: '700' }}>
                  Coming Soon
                </h1>
                <p style={{
                  fontSize: '20px',
                  marginBottom: '40px',
                  opacity: 0.95,
                  lineHeight: '1.6'
                }}>
                  We're building something extraordinary for mental health and wellness. 
                  Be the first to know when we launch!
                </p>

                <div style={{
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  padding: '50px',
                  borderRadius: '15px',
                  backdropFilter: 'blur(10px)',
                  marginBottom: '40px'
                }}>
                  {!submitted ? (
                    <form onSubmit={handleSubmit} style={{ marginBottom: '30px' }}>
                      <div style={{
                        display: 'flex',
                        gap: '10px',
                        marginBottom: '20px',
                        flexWrap: 'wrap'
                      }}>
                        <input
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Enter your email address"
                          required
                          style={{
                            flex: 1,
                            minWidth: '250px',
                            padding: '15px 20px',
                            border: 'none',
                            borderRadius: '8px',
                            fontFamily: 'inherit',
                            fontSize: '16px'
                          }}
                        />
                        <button
                          type="submit"
                          className="thm-btn"
                          style={{
                            padding: '15px 40px',
                            backgroundColor: '#fff',
                            color: '#667eea',
                            fontWeight: '600',
                            minWidth: '150px'
                          }}
                        >
                          Join Waitlist
                        </button>
                      </div>
                    </form>
                  ) : (
                    <div style={{
                      padding: '30px',
                      backgroundColor: 'rgba(255,255,255,0.2)',
                      borderRadius: '10px',
                      marginBottom: '20px'
                    }}>
                      <h3 style={{ marginBottom: '10px', fontSize: '24px' }}>✓ Thank You!</h3>
                      <p>Check your email for updates about our launch.</p>
                    </div>
                  )}

                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '30px',
                    flexWrap: 'wrap'
                  }}>
                    <div>
                      <div style={{ fontSize: '32px', fontWeight: 'bold' }}>{waitlistCount.toLocaleString()}</div>
                      <div style={{ fontSize: '14px', opacity: 0.9 }}>People on waitlist</div>
                    </div>
                    <div style={{
                      width: '1px',
                      backgroundColor: 'rgba(255,255,255,0.3)'
                    }}></div>
                    <div>
                      <div style={{ fontSize: '32px', fontWeight: 'bold' }}>100+</div>
                      <div style={{ fontSize: '14px', opacity: 0.9 }}>Expert professionals</div>
                    </div>
                    <div style={{
                      width: '1px',
                      backgroundColor: 'rgba(255,255,255,0.3)'
                    }}></div>
                    <div>
                      <div style={{ fontSize: '32px', fontWeight: 'bold' }}>24/7</div>
                      <div style={{ fontSize: '14px', opacity: 0.9 }}>Support available</div>
                    </div>
                  </div>
                </div>

                <p style={{ fontSize: '14px', opacity: 0.8 }}>
                  We respect your privacy. You'll only receive updates about our launch.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section style={{ padding: '80px 0', backgroundColor: '#f9f9f9' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center wow fadeInUp" style={{ marginBottom: '50px' }}>
                <h2 className="section-title__title">What's Coming</h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-6 wow fadeInUp" style={{ marginBottom: '30px' }}>
              <div style={{
                backgroundColor: '#fff',
                padding: '40px',
                borderRadius: '10px',
                textAlign: 'center',
                boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
              }}>
                <div style={{ fontSize: '50px', marginBottom: '15px' }}>🔒</div>
                <h3 style={{ marginBottom: '15px' }}>Verified Professionals</h3>
                <p>Access to verified and licensed mental health professionals</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 wow fadeInUp" style={{ marginBottom: '30px' }}>
              <div style={{
                backgroundColor: '#fff',
                padding: '40px',
                borderRadius: '10px',
                textAlign: 'center',
                boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
              }}>
                <div style={{ fontSize: '50px', marginBottom: '15px' }}>💻</div>
                <h3 style={{ marginBottom: '15px' }}>Online & Offline Sessions</h3>
                <p>Flexible scheduling with sessions available both online and offline</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 wow fadeInUp" style={{ marginBottom: '30px' }}>
              <div style={{
                backgroundColor: '#fff',
                padding: '40px',
                borderRadius: '10px',
                textAlign: 'center',
                boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
              }}>
                <div style={{ fontSize: '50px', marginBottom: '15px' }}>📚</div>
                <h3 style={{ marginBottom: '15px' }}>Learning Resources</h3>
                <p>Access to exclusive e-learning content and self-help tools</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 wow fadeInUp" style={{ marginBottom: '30px' }}>
              <div style={{
                backgroundColor: '#fff',
                padding: '40px',
                borderRadius: '10px',
                textAlign: 'center',
                boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
              }}>
                <div style={{ fontSize: '50px', marginBottom: '15px' }}>👥</div>
                <h3 style={{ marginBottom: '15px' }}>Community Support</h3>
                <p>Connect with others, share experiences, and build meaningful relationships</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 wow fadeInUp" style={{ marginBottom: '30px' }}>
              <div style={{
                backgroundColor: '#fff',
                padding: '40px',
                borderRadius: '10px',
                textAlign: 'center',
                boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
              }}>
                <div style={{ fontSize: '50px', marginBottom: '15px' }}>🎯</div>
                <h3 style={{ marginBottom: '15px' }}>Personalized Plans</h3>
                <p>Customized wellness plans tailored to your unique needs</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 wow fadeInUp" style={{ marginBottom: '30px' }}>
              <div style={{
                backgroundColor: '#fff',
                padding: '40px',
                borderRadius: '10px',
                textAlign: 'center',
                boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
              }}>
                <div style={{ fontSize: '50px', marginBottom: '15px' }}>🔔</div>
                <h3 style={{ marginBottom: '15px' }}>Reminders & Tracking</h3>
                <p>Smart reminders and progress tracking for your wellness journey</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Features Section End */}
    </>
  );
}

export default WaitlistPage;
